import * as RecommendationsByResultId from '../../../services/api/recommendationsByResultId'
import { useApiRequest } from '../../useApiRequest'

export const useGetRecomendationsByResultId = resultId => {
  const { data, loading, error } = useApiRequest(RecommendationsByResultId.fetchAll(resultId))

  return { data, loading, error }
}
